import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateTierMutation = createMutationHook(MembershipsCreatorV2ApiClient.updateTier, {
  mutationKey: ['updateTier'],
})
